import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'ModalQuickMenuStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalQuickMenuStore extends BaseStore {
  _isOpen = false

  get isOpen(): boolean {
    return this._isOpen
  }

  @Mutation
  public open() {
    this._isOpen = true
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public cancel() {
    this._isOpen = false
  }
}
